import { updates } from '@/mocks/baoliao';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            实时快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            24小时不间断更新，最新爆料第一时间送达
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-4 md:left-5 top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updates.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-12">
                <div className={`absolute left-3 md:left-[17px] w-2.5 h-2.5 rounded-full border-2 border-background-100 ${
                  item.urgent ? 'bg-primary-500' : 'bg-secondary-400'
                }`}></div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`text-xs font-semibold whitespace-nowrap ${
                      item.urgent ? 'text-primary-600' : 'text-foreground-500'
                    }`}>
                      {item.time}
                    </span>
                    {item.urgent && (
                      <span className="text-xs px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 font-bold whitespace-nowrap">
                        突发
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}